module.exports = __webpack_public_path__ + "img/arcos-c.8c7e2aac.jpg";